import React from 'react'
import { HashLoader } from 'react-spinners'

const ProgressIndicator = ({ color = '#5383ff' }) => (
  <div className='h-75 w-100 d-flex flex-column justify-content-center align-items-center text-center'>
    <div className='d-flex align-items-center flex-column p-4'>
      <HashLoader color={color} loading />
    </div>
  </div>
)

export default ProgressIndicator
